import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ImageContainer component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    DVContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',

      '&[data-ui-type=primary]': {
        // paddingTop: theme.spacing(1),
        // paddingBottom: theme.spacing(2),
        // '& $imageSection': {
        //   marginBottom: theme.spacing(2),
        // },
        // '& $caption': {
        //   marginBottom: theme.spacing(1),
        // },
      },
    },

    panelHeader: {
      marginBottom: '0.4rem',
    },

    nameContainer: {
      display: 'flex',
      gap: '1.7rem',
      justifyContent: 'space-between',
    },

    elementName: {
      fontWeight: 800,
    },

    contentContainer: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      overflowY: 'hidden',
      padding: '2rem 1.6rem',
    },

    settingsContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxHeight: 'calc(100vh - 228px)',
      overflowY: 'auto',

      '& .MuiAccordion-root': {
        '&:not(:last-child)': {
          paddingBottom: '2rem',
        },
      },
    },

    accordion: {
      background: 'green',
    },

    actions: {
      display: 'flex',
      padding: '0 0 1.6rem 0',
      alignItems: 'center',
      justifyContent: 'space-between',
      ['@media (max-width: 1650px)']: {
        alignItems: 'end',
        flexDirection: 'column',
        gap: '1.7rem',
      },
    },

    deployment: {
      width: '26rem',
      ['@media (max-width: 1650px)']: {
        width: '100%',
      },
    },

    generateImagesWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
    },

    DVSegmentItem: {
      marginTop: '15px',
    },

    progressItem: {
      position: 'relative',
      display: 'flex',
      gap: '15px',
      alignItems: 'center',
      marginBottom: '3px',
      marginTop: '10px',
    },

    DVSegmentItemLabel: {
      fontWeight: 'bold',
    },

    DVSegmentItemName: {
      lineHeight: '12px',
      marginBottom: '5px',
    },

    genStatusLabel: {
      width: '150px',
      fontWeight: 'bold',
    },

    infoItem: {
      display: 'flex',
      gap: '15px',
      marginTop: '20px',
    },

    infoItemLabel: {
      fontWeight: 'bold',
    },

    grayText: {
      color: variables.color.secondary.gray,
    },

    loading: {
      transform: 'scale(0.5)',
      marginTop: '-10px',
    },

    generateBtn: {
      height: '3.3rem',
      lineHeight: '1.4rem',
      width: '13.8rem',
    },

    imageProgress: {
      width: 'calc(100% - 162px)',
    },

    uploadDefaultImage: {
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },

    genResult: {
      position: 'absolute',
      fontWeight: 'initial',
      right: '0',
    },

    selectBtn: {
      height: '3.2rem',
      width: '6.5rem',
    },

    label: {
      display: 'flex',
      gap: '5px',
      marginTop: '0',
      marginBottom: '5px',
      fontWeight: 800,
    },

    feature: {
      marginBottom: '25px',
    },

    featureSection: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '20px',
    },

    featureTop: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'space-between',
      paddingBottom: '10px',
    },
    featureInput: {
      width: '100%',

      '& input': {
        height: '3rem',
      },
    },
    dvImagePathFieldContainer: {
      display: 'flex',
      gap: '1.7rem',
    },
    sourceCodeSection: {
      display: 'flex',
      gap: '10px',
      marginBottom: '10px',
    },

    codeEditor: {
      // maxHeight: 'calc(100vh - 460px)',
      maxHeight: 'unset',
    },

    titleWrapper: {
      flex: '0 0 auto',
      padding: '0 1.6rem 2rem 0',
    },
    title: {
      alignItems: 'center',
      color: variables.colorV2.text.header,
      display: 'flex',
      fontSize: '2rem',
      fontWeight: 400,
      justifyContent: 'space-between',
      lineHeight: '2.5rem',
      // paddingBottom: '1rem',
    },

    content: {
      padding: '0 0 1.6rem 0',
      flexDirection: 'column',
    },

    itemValue: {
      fontWeight: 700,
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
    },

    closeBtn: {
      height: '3.2rem',
      marginRight: '0.8rem',
      width: '6.5rem',
    },

    saveBtn: {},
  }),
);
